import { render, staticRenderFns } from "./ProductionValueCombo.vue?vue&type=template&id=153cbce8&scoped=true"
import script from "./ProductionValueCombo.vue?vue&type=script&lang=ts"
export * from "./ProductionValueCombo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153cbce8",
  null
  
)

export default component.exports